//@ts-check
import React from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const OneTabSimulation = ({ title, classes }) => (
  <>
    <Box className={classes.tabBox}>
      <Box className={classes.tabElement}>
        <Typography variant="subtitle2" className={classes.tabTitle}>
          {title}
        </Typography>
        <Divider className={classes.tabDivider} variant="fullWidth" />
      </Box>
    </Box>
    <Divider />
  </>
);

OneTabSimulation.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  title: PropTypes.string,
};

OneTabSimulation.defaultProps = {
  title: '',
  classes: {},
};

export default OneTabSimulation;
